import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-itc.jpg",
  heading: "IT Consulting",
  description: `Our IT Consulting services empower businesses to align their technology strategies with their goals. We assess your current infrastructure, identify areas for improvement, and deliver strategic guidance to drive innovation and efficiency. Whether you're planning digital transformation, cloud adoption, or cybersecurity enhancements, our consultants provide expert insights and actionable plans.`,

  middleImage: "/images/service/sr-d-1-2-itc.jpg",
  features: [
    "Technology Strategy & Roadmapping",
    "Digital Transformation Consulting",
    "Cloud & Infrastructure Advisory",
    "Cybersecurity Risk Assessment",
  ],

  challengeHeading: "Challenges in IT Consulting",
  challengeParagraphs: [
    `Many businesses struggle to keep up with rapidly evolving technologies, leading to inefficient systems and missed opportunities. Choosing the right solutions and implementing them effectively requires expert analysis and strategic thinking.`,
    `Our consulting approach focuses on delivering tailored recommendations that align with your business objectives, reduce risk, and improve ROI through thoughtful technology investments.`,
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg",
  ],
};

const ITConsulting = () => (
  <Fragment>
    <Seo
      title="IT Consulting Services - Tech Ayukta"
      description="Tech Ayukta provides expert IT consulting services to streamline business processes, adopt modern technologies, and build scalable digital strategies."
      keywords="IT Consulting, Technology Consulting, Digital Strategy, Business IT Solutions, Tech Ayukta"
      canonical="https://www.techayukta.com/services/it-consulting"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="IT Consulting"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default ITConsulting;
